<template>
    <div class="detail-data-block" :class="{ 'group-wrapper': isMobile }">
        <!-- Operator Data Divider -->
        <divider-generic
        icon="profile"
        :title="t('approvals.signed.modal.details.operatorDetails.operatorDataTitle')"/>
		<!-- Username -->
        <text-block-generic
        v-if="operatorDetails.username"
        :params="{ label: t('approvals.signed.modal.details.operatorDetails.usernameLabel'), content: operatorDetails.username }"/>
        <!-- Name -->
        <text-block-generic
        :params="{ label: t('approvals.signed.modal.details.operatorDetails.nameLabel'), content: operatorDetails.name }"/>
        <!-- Email -->
        <text-block-generic
        :params="{ label: t('approvals.signed.modal.details.operatorDetails.emailLabel'), content: operatorDetails.email }"/>
        <!-- Phone -->
        <text-block-generic
        :params="{ label: t('approvals.signed.modal.details.operatorDetails.phoneLabel'), content: operatorDetails.msisdn }"/>
        <!-- Nif -->
        <text-block-generic
        :params="{ label: t('approvals.signed.modal.details.operatorDetails.nifLabel'), content: operatorDetails.nif ? operatorDetails.nif : '-' }"/>
        <!-- Access To New Accounts -->
        <text-block-generic
        :params="{
            label: t('approvals.signed.modal.details.operatorDetails.accessToNewAccountsLabel'),
            content: operatorDetails.accessToNewAccounts ? t('approvals.signed.modal.details.operatorDetails.yes') : t('approvals.signed.modal.details.operatorDetails.no')
        }"/>
        <!-- Profile -->
        <text-block-generic
        :params="{ label: t('approvals.signed.modal.details.operatorDetails.profileLabel'), content: operatorDetails.profile.operatorProfileDescription }"/>
        <!-- Weight -->
        <text-block-generic
        v-if="operatorDetails.weight"
        :params="{ label: t('approvals.signed.modal.details.operatorDetails.weightLabel'), content: `${operatorDetails.weight}%` }"/>
    </div>
</template>

<script setup>
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'
/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['resetPassword'])

/** Props
@operatorDetails {Object}
@isMobile {Boolean}
*/
const props = defineProps({
    operatorDetails: Object,
    isMobile: Boolean
})
</script>

<style lang="scss" scoped>
.detail-data-block {
    display: flex;
    flex-direction: column;
    gap: 24px;
}
</style>
